/* eslint-disable react-hooks/exhaustive-deps */
import {
    CircularProgress,
    Grid,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import useFetchCompany from "../../../data/hooks/useFetchCompany";
import useCashRegisterForm from "../CashRegisterForm/hooks/useCashRegisterForm";

const CashPicker = ({ onSubmit, setSelectedCashRegister }) => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const registerId = searchParams.get("rid");
    const { formData, setFormData, handleSubmit } = useCashRegisterForm({
        onSubmit,
    });
    const [selectedId, setSelectedId] = useState("");

    const { user } = useAuth();

    const { company, loading } = useFetchCompany({ skip: 0, limit: 20 });

    useEffect(() => {
        if (!formData.number) return;
        handleSubmit();
    }, [formData.number]);

    useEffect(() => {
        if (!registerId || !company || loading) return;

        const selectedCash = company.cash_registers.find(
            (cash) => cash._id === Number.parseInt(registerId)
        );
        if (!selectedCash) return;

        setSelectedId(selectedCash._id.toString());

        setFormData({
            idnx: company.idno,
            address: selectedCash.address,
            factory: selectedCash.factory,
            key: selectedCash.key,
            model: selectedCash.model,
            name: company.name,
            number: selectedCash.number,
            point: selectedCash.point,
        });

        if (setSelectedCashRegister) {
            setSelectedCashRegister(selectedCash);
        }
    }, [registerId, company, loading]);

    const cashRegisters = useMemo(() => {
        let listCash = company?.cash_registers || [];

        if (user && user.role === "USER") {
            listCash = (company?.cash_registers || []).filter((cash) =>
                user.cashRegisterIds.includes(cash._id)
            );
        }

        return listCash?.filter((cash) => !!cash.number) || [];
        // company.cash_registers
    }, [user, company]);

    // Auto-select if only one cash register is available
    useEffect(() => {
        if (!cashRegisters.length || selectedId || registerId) return;

        if (cashRegisters.length === 1) {
            const selectedCash = cashRegisters[0];
            setSelectedId(selectedCash._id.toString());
            setFormData({
                idnx: company.idno,
                address: selectedCash.address,
                factory: selectedCash.factory,
                key: selectedCash.key,
                model: selectedCash.model,
                name: company.name,
                number: selectedCash.number,
                point: selectedCash.point,
            });

            if (setSelectedCashRegister) {
                setSelectedCashRegister(selectedCash);
            }
        }
    }, [cashRegisters, selectedId, registerId, company]);

    if (loading || !company) return null;

    const handleCashSelect = (e) => {
        const selectedValue = e.target.value;

        const selectedCash = cashRegisters.find(
            (cash) => cash._id.toString() === selectedValue
        );

        if (!selectedCash) return;

        setSelectedId(selectedValue);
        setFormData({
            idnx: company.idno,
            address: selectedCash.address,
            factory: selectedCash.factory,
            key: selectedCash.key,
            model: selectedCash.model,
            name: company.name,
            number: selectedCash.number,
            point: selectedCash.point,
        });

        if (setSelectedCashRegister) {
            setSelectedCashRegister(selectedCash);
        }
    };

    return (
        <>
            <Grid container sx={{ marginTop: 2 }} spacing={2} align="left">
                <Grid item xs={5}>
                    <Typography
                        sx={{ fontSize: 24, marginTop: 2 }}
                        gutterBottom
                    >
                        eKassa:
                    </Typography>
                </Grid>
            </Grid>
            <Grid container sx={{ marginTop: 2 }} spacing={2} align="left">
                <Grid
                    item
                    direction={"row"}
                    xs={5}
                    sx={{ display: "flex", alignItems: "center", gap: 2 }}
                >
                    <Select
                        id="cash-register-select"
                        labelId="cash-register-select-label"
                        variant="standard"
                        label={t("cash_machine")}
                        value={selectedId || ""}
                        size="small"
                        name="number"
                        disabled={loading || cashRegisters.length <= 1}
                        sx={{ width: 500 }}
                        onChange={handleCashSelect}
                        displayEmpty
                        placeholder={t("select_ekassa")}
                        renderValue={(selected) => {
                            if (!selected) {
                                return <em>{t("select_ekassa")}</em>;
                            }
                            const selectedCash = cashRegisters.find(
                                (cash) => cash._id.toString() === selected
                            );
                            return selectedCash
                                ? `${selectedCash.model} ${selectedCash.number}`
                                : selected;
                        }}
                    >
                        {cashRegisters.map((cashRegister) => (
                            <MenuItem
                                key={cashRegister._id || cashRegister.id}
                                value={cashRegister._id.toString()}
                            >
                                {`${cashRegister.model} ${cashRegister.number}`}
                            </MenuItem>
                        ))}
                    </Select>
                    {loading && <CircularProgress size={16} />}
                </Grid>
            </Grid>
        </>
    );
};

export default CashPicker;
